import { Box, Typography } from '@mui/material';
import { REFRESH, REFRESH_OR_SAVE } from '../../constants';
import ButtonComponent from '../FormComponents/Button';
import Modal from '../Modal/Modal';

interface SaveOrRefreshProps {
  saveOrRefreshPopup: string;
  save: () => void;
  refresh: () => void;
  loading?: boolean;
}

function SaveOrRefresh(props: SaveOrRefreshProps) {
  const { saveOrRefreshPopup, save, refresh, loading } = props;

  return (
    <>
      <Modal
        fullWidth
        open={!!saveOrRefreshPopup}
        title={saveOrRefreshPopup === REFRESH ? 'You need to refresh' : 'New survey version is available'}
        button={<ButtonComponent text='Refresh to get changes' variant='outlined' onClick={refresh} />}
        secondButton={
          saveOrRefreshPopup === REFRESH_OR_SAVE ? (
            <ButtonComponent text='Save' onClick={save} loading={loading} />
          ) : (
            <></>
          )
        }
        data={
          <Box>
            {saveOrRefreshPopup === REFRESH ? (
              <Typography variant='body1'>
                Please refresh because the section you were working on is already being worked on by other user.
              </Typography>
            ) : (
              <Typography variant='body1'>
                If you save you will make your version overwrite the latest version. Otherwise if you refresh you will
                get the latest version and lose your unsaved changes.
              </Typography>
            )}
          </Box>
        }
      />
    </>
  );
}

export default SaveOrRefresh;
